"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOCKED_FEATURES = exports.BLOCKED_FLEET_ADMIN_CLAIMS = exports.BLOCKED_DTNA_CLAIMS = exports.BLOCKED_CLAIMS = exports.POTA = exports.FOTA = exports.ANALYTICS_SAFETY_VIN = exports.ANALYTICS = exports.PreconditioningClaims = exports.RemoteLockUnlockClaim = exports.MfeToolkitClaim = exports.FleetContactsClaim = exports.DepartureProfileClaims = exports.RangePredictionClaims = exports.SessionManagementClaims = exports.DispenserManagementClaims = exports.DepotManagementClaims = exports.GeofenceEditorClaim = exports.VehicleInformationUnitIDClaim = exports.VehicleContactsClaim = exports.VehiclesClaim = exports.UsersClaim = exports.ShareClaim = exports.SettingsClaim = exports.GeofenceNotificationsClaim = exports.FaultsNotificationsClaim = exports.SafetyNotificationsClaim = exports.SafetyDCVCVehicleClaim = exports.SafetyDCVCFleetClaim = exports.SafetyAnalyticsVehicleClaim = exports.PremiumSafetyVehicleClaim = exports.PremiumSafetyFleetClaim = exports.SafetyAnalyticsFleetClaim = exports.RolesClaim = exports.POTAClaim = exports.PoliciesClaim = exports.MaintenanceSystemClaim = exports.FuelAnalyticsClaim = exports.FOTAVehicleClaim = exports.FOTAClaim = exports.FaultsClaim = exports.FaultFlagClaim = exports.EventsClaim = exports.DealersClaim = exports.DDECClaim = exports.CustomersClaim = exports.AnalyticsClaim = exports.TelematicsFeature = void 0;
var TelematicsFeature;
(function (TelematicsFeature) {
    TelematicsFeature[TelematicsFeature["FOTA"] = 0] = "FOTA";
    TelematicsFeature[TelematicsFeature["POTA"] = 1] = "POTA";
})(TelematicsFeature = exports.TelematicsFeature || (exports.TelematicsFeature = {}));
var AnalyticsClaim;
(function (AnalyticsClaim) {
    AnalyticsClaim["FUEL"] = "FuelAnalytics_View";
    AnalyticsClaim["SAFETY_FLEET"] = "SafetyAnalyticsFleet_View";
    AnalyticsClaim["SAFETY_VEHICLE"] = "SafetyAnalyticsVehicle_View";
})(AnalyticsClaim = exports.AnalyticsClaim || (exports.AnalyticsClaim = {}));
var CustomersClaim;
(function (CustomersClaim) {
    CustomersClaim["READ"] = "Customers_View";
})(CustomersClaim = exports.CustomersClaim || (exports.CustomersClaim = {}));
var DDECClaim;
(function (DDECClaim) {
    DDECClaim["REQUEST"] = "DDEC_Request";
    DDECClaim["READ"] = "DDEC_View";
})(DDECClaim = exports.DDECClaim || (exports.DDECClaim = {}));
var DealersClaim;
(function (DealersClaim) {
    DealersClaim["READ"] = "Dealers_View";
})(DealersClaim = exports.DealersClaim || (exports.DealersClaim = {}));
var EventsClaim;
(function (EventsClaim) {
    EventsClaim["READ"] = "Events_View";
})(EventsClaim = exports.EventsClaim || (exports.EventsClaim = {}));
var FaultFlagClaim;
(function (FaultFlagClaim) {
    FaultFlagClaim["CREATE"] = "FaultFlag_Create";
    FaultFlagClaim["DELETE"] = "FaultFlag_Delete";
})(FaultFlagClaim = exports.FaultFlagClaim || (exports.FaultFlagClaim = {}));
var FaultsClaim;
(function (FaultsClaim) {
    FaultsClaim["RESOLVE"] = "Faults_Resolve";
})(FaultsClaim = exports.FaultsClaim || (exports.FaultsClaim = {}));
var FOTAClaim;
(function (FOTAClaim) {
    FOTAClaim["APPROVE"] = "Approve_Firmware";
    FOTAClaim["READ"] = "Read_Firmware";
})(FOTAClaim = exports.FOTAClaim || (exports.FOTAClaim = {}));
var FOTAVehicleClaim;
(function (FOTAVehicleClaim) {
    FOTAVehicleClaim["APPROVE"] = "Firmware_Post";
    FOTAVehicleClaim["READ"] = "Firmware_Get";
})(FOTAVehicleClaim = exports.FOTAVehicleClaim || (exports.FOTAVehicleClaim = {}));
var FuelAnalyticsClaim;
(function (FuelAnalyticsClaim) {
    FuelAnalyticsClaim["READ"] = "FuelAnalytics_View";
})(FuelAnalyticsClaim = exports.FuelAnalyticsClaim || (exports.FuelAnalyticsClaim = {}));
var MaintenanceSystemClaim;
(function (MaintenanceSystemClaim) {
    MaintenanceSystemClaim["READ"] = "MaintenanceSystem_View";
})(MaintenanceSystemClaim = exports.MaintenanceSystemClaim || (exports.MaintenanceSystemClaim = {}));
var PoliciesClaim;
(function (PoliciesClaim) {
    PoliciesClaim["CREATE"] = "Policies_Create";
    PoliciesClaim["READ"] = "Policies_View";
    PoliciesClaim["UPDATE"] = "Policies_Edit";
    PoliciesClaim["DELETE"] = "Policies_Remove";
})(PoliciesClaim = exports.PoliciesClaim || (exports.PoliciesClaim = {}));
var POTAClaim;
(function (POTAClaim) {
    POTAClaim["ASSIGN"] = "Assign_Profiles";
    POTAClaim["READ"] = "Profiles_Get";
    POTAClaim["MANAGE"] = "Manage_Profiles";
})(POTAClaim = exports.POTAClaim || (exports.POTAClaim = {}));
var RolesClaim;
(function (RolesClaim) {
    RolesClaim["CREATE"] = "Roles_Create";
    RolesClaim["READ"] = "Roles_View";
    RolesClaim["UPDATE"] = "Roles_Edit";
    RolesClaim["DELETE"] = "Roles_Remove";
})(RolesClaim = exports.RolesClaim || (exports.RolesClaim = {}));
var SafetyAnalyticsFleetClaim;
(function (SafetyAnalyticsFleetClaim) {
    SafetyAnalyticsFleetClaim["READ"] = "SafetyAnalyticsFleet_View";
})(SafetyAnalyticsFleetClaim = exports.SafetyAnalyticsFleetClaim || (exports.SafetyAnalyticsFleetClaim = {}));
var PremiumSafetyFleetClaim;
(function (PremiumSafetyFleetClaim) {
    PremiumSafetyFleetClaim["READ"] = "SafetyPlusFleet_View";
})(PremiumSafetyFleetClaim = exports.PremiumSafetyFleetClaim || (exports.PremiumSafetyFleetClaim = {}));
var PremiumSafetyVehicleClaim;
(function (PremiumSafetyVehicleClaim) {
    PremiumSafetyVehicleClaim["READ"] = "SafetyPlusVehicle_View";
})(PremiumSafetyVehicleClaim = exports.PremiumSafetyVehicleClaim || (exports.PremiumSafetyVehicleClaim = {}));
var SafetyAnalyticsVehicleClaim;
(function (SafetyAnalyticsVehicleClaim) {
    SafetyAnalyticsVehicleClaim["READ"] = "SafetyAnalyticsVehicle_View";
})(SafetyAnalyticsVehicleClaim = exports.SafetyAnalyticsVehicleClaim || (exports.SafetyAnalyticsVehicleClaim = {}));
var SafetyDCVCFleetClaim;
(function (SafetyDCVCFleetClaim) {
    SafetyDCVCFleetClaim["READ"] = "DCVCSafetyFleet_View";
    SafetyDCVCFleetClaim["MANAGE"] = "DCVCSafetyFleet_Manage";
})(SafetyDCVCFleetClaim = exports.SafetyDCVCFleetClaim || (exports.SafetyDCVCFleetClaim = {}));
var SafetyDCVCVehicleClaim;
(function (SafetyDCVCVehicleClaim) {
    SafetyDCVCVehicleClaim["READ"] = "DCVCSafetyVehicle_View";
    SafetyDCVCVehicleClaim["MANAGE"] = "DCVCSafetyVehicle_Manage";
})(SafetyDCVCVehicleClaim = exports.SafetyDCVCVehicleClaim || (exports.SafetyDCVCVehicleClaim = {}));
var SafetyNotificationsClaim;
(function (SafetyNotificationsClaim) {
    SafetyNotificationsClaim["READ"] = "SafetyNotifications_Read";
    SafetyNotificationsClaim["UPDATE"] = "SafetyNotifications_Update";
})(SafetyNotificationsClaim = exports.SafetyNotificationsClaim || (exports.SafetyNotificationsClaim = {}));
var FaultsNotificationsClaim;
(function (FaultsNotificationsClaim) {
    FaultsNotificationsClaim["READ"] = "FaultsNotifications_Read";
    FaultsNotificationsClaim["UPDATE"] = "FaultsNotifications_Update";
})(FaultsNotificationsClaim = exports.FaultsNotificationsClaim || (exports.FaultsNotificationsClaim = {}));
var GeofenceNotificationsClaim;
(function (GeofenceNotificationsClaim) {
    GeofenceNotificationsClaim["READ"] = "Notification_Geofence_Read";
    GeofenceNotificationsClaim["UPDATE"] = "Notification_Geofence_Manage";
})(GeofenceNotificationsClaim = exports.GeofenceNotificationsClaim || (exports.GeofenceNotificationsClaim = {}));
var SettingsClaim;
(function (SettingsClaim) {
    SettingsClaim["UPDATE"] = "Settings_Edit";
    SettingsClaim["READ"] = "Settings_View";
})(SettingsClaim = exports.SettingsClaim || (exports.SettingsClaim = {}));
var ShareClaim;
(function (ShareClaim) {
    ShareClaim["CREATE"] = "Share_Post";
})(ShareClaim = exports.ShareClaim || (exports.ShareClaim = {}));
var UsersClaim;
(function (UsersClaim) {
    UsersClaim["CREATE"] = "Users_Create";
    UsersClaim["READ"] = "Users_View";
    UsersClaim["UPDATE"] = "Users_Edit";
    UsersClaim["DELETE"] = "Users_Remove";
})(UsersClaim = exports.UsersClaim || (exports.UsersClaim = {}));
var VehiclesClaim;
(function (VehiclesClaim) {
    VehiclesClaim["CREATE"] = "Vehicles_Create";
    VehiclesClaim["PUT"] = "Vehicles_Put";
    VehiclesClaim["READ"] = "Vehicles_View";
    VehiclesClaim["UPDATE"] = "Vehicles_Edit";
    VehiclesClaim["DELETE"] = "Vehicles_Remove";
})(VehiclesClaim = exports.VehiclesClaim || (exports.VehiclesClaim = {}));
var VehicleContactsClaim;
(function (VehicleContactsClaim) {
    VehicleContactsClaim["UPDATE"] = "VehicleContacts_Edit";
})(VehicleContactsClaim = exports.VehicleContactsClaim || (exports.VehicleContactsClaim = {}));
var VehicleInformationUnitIDClaim;
(function (VehicleInformationUnitIDClaim) {
    VehicleInformationUnitIDClaim["UPDATE"] = "VehicleUnitID_Put";
})(VehicleInformationUnitIDClaim = exports.VehicleInformationUnitIDClaim || (exports.VehicleInformationUnitIDClaim = {}));
var GeofenceEditorClaim;
(function (GeofenceEditorClaim) {
    GeofenceEditorClaim["MANAGE"] = "Geofence_Manage";
    GeofenceEditorClaim["READ"] = "Geofence_Read";
})(GeofenceEditorClaim = exports.GeofenceEditorClaim || (exports.GeofenceEditorClaim = {}));
var DepotManagementClaims;
(function (DepotManagementClaims) {
    DepotManagementClaims["WRITE"] = "DepotManagement_Write";
    DepotManagementClaims["READ"] = "DepotManagement_Read";
})(DepotManagementClaims = exports.DepotManagementClaims || (exports.DepotManagementClaims = {}));
var DispenserManagementClaims;
(function (DispenserManagementClaims) {
    DispenserManagementClaims["WRITE"] = "ChargeManagement_Write";
    DispenserManagementClaims["READ"] = "ChargeManagement_Read";
})(DispenserManagementClaims = exports.DispenserManagementClaims || (exports.DispenserManagementClaims = {}));
var SessionManagementClaims;
(function (SessionManagementClaims) {
    SessionManagementClaims["WRITE"] = "ChargerScheduling_Write";
    SessionManagementClaims["READ"] = "ChargerScheduling_Read";
})(SessionManagementClaims = exports.SessionManagementClaims || (exports.SessionManagementClaims = {}));
var RangePredictionClaims;
(function (RangePredictionClaims) {
    RangePredictionClaims["WRITE"] = "RangePrediction_Write";
    RangePredictionClaims["READ"] = "RangePrediction_Read";
})(RangePredictionClaims = exports.RangePredictionClaims || (exports.RangePredictionClaims = {}));
var DepartureProfileClaims;
(function (DepartureProfileClaims) {
    DepartureProfileClaims["WRITE"] = "DepartureProfile_Write";
    DepartureProfileClaims["READ"] = "DepartureProfile_Read";
})(DepartureProfileClaims = exports.DepartureProfileClaims || (exports.DepartureProfileClaims = {}));
var FleetContactsClaim;
(function (FleetContactsClaim) {
    FleetContactsClaim["UPDATE"] = "FleetContacts_Edit";
})(FleetContactsClaim = exports.FleetContactsClaim || (exports.FleetContactsClaim = {}));
var MfeToolkitClaim;
(function (MfeToolkitClaim) {
    MfeToolkitClaim["READ"] = "MfeToolkit_View";
})(MfeToolkitClaim = exports.MfeToolkitClaim || (exports.MfeToolkitClaim = {}));
var RemoteLockUnlockClaim;
(function (RemoteLockUnlockClaim) {
    RemoteLockUnlockClaim["WRITE"] = "RemoteLockUnlock_Write";
    RemoteLockUnlockClaim["READ"] = "RemoteLockUnlock_Read";
})(RemoteLockUnlockClaim = exports.RemoteLockUnlockClaim || (exports.RemoteLockUnlockClaim = {}));
var PreconditioningClaims;
(function (PreconditioningClaims) {
    PreconditioningClaims["WRITE"] = "Preconditioning_Write";
    PreconditioningClaims["READ"] = "Preconditioning_Read";
})(PreconditioningClaims = exports.PreconditioningClaims || (exports.PreconditioningClaims = {}));
// ALL ANALYTICS
exports.ANALYTICS = [[
        AnalyticsClaim.FUEL,
        AnalyticsClaim.SAFETY_FLEET,
        AnalyticsClaim.SAFETY_VEHICLE,
    ]];
// ANALYTICS SAFETY VIN
exports.ANALYTICS_SAFETY_VIN = [[
        AnalyticsClaim.SAFETY_VEHICLE,
    ]];
// ALL FOTA
exports.FOTA = [[
        FOTAClaim.APPROVE,
        FOTAClaim.READ,
    ]];
// ALL POTA
exports.POTA = [[
        POTAClaim.ASSIGN,
        POTAClaim.MANAGE,
        POTAClaim.READ,
    ]];
// BLOCKED FOR EVERYONE
exports.BLOCKED_CLAIMS = [];
// BLOCKED FOR DTNA USER AND BELOW (ROOT AND FLEET ADMIN ONLY ENABLED)
exports.BLOCKED_DTNA_CLAIMS = [
    AnalyticsClaim.SAFETY_FLEET,
    AnalyticsClaim.SAFETY_VEHICLE,
    SafetyNotificationsClaim.UPDATE,
    GeofenceEditorClaim.MANAGE,
    RemoteLockUnlockClaim.WRITE,
];
// BLOCKED FOR FLEET ADMIN AND BELOW (ROOT + DTNA ENABLED)
exports.BLOCKED_FLEET_ADMIN_CLAIMS = [];
exports.BLOCKED_FEATURES = [];
var claimsExport = {
    ANALYTICS: exports.ANALYTICS,
    BLOCKED_CLAIMS: exports.BLOCKED_CLAIMS,
    BLOCKED_DTNA_CLAIMS: exports.BLOCKED_DTNA_CLAIMS,
    FOTA: exports.FOTA,
    POTA: exports.POTA,
};
exports.default = claimsExport;
